(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxDeleteSignInProfile(
    $http, toastr, $filter, $rootScope, $location
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        goProfile: '=goProfile',
        onDeviceConfig: '=onDeviceConfig',
        meta: '=meta',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/signInProfileProperties/deleteSignInProfile/deleteSignInProfile.template.html',
      link: function(scope) {

        scope.confirm = {
          delete: false
        };

        scope.delete = function () {
          if (scope.goProfile) {
            deleteSignInProfile();
          }

          if (scope.onDeviceConfig) {
            deleteOnDeviceConfig();
          }
        }

        function deleteSignInProfile () {
          var url = scope.goProfile.info._links.self.href;
          $http.delete(url).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
            $rootScope.$broadcast('REMOVE_SIGN_IN_PROFILE', {goProfile: scope.goProfile.info._links.self.href});
            if ($location.$$path.indexOf('signInProfile') > 0) {
              $location.path('/settings').search({'settingsSection': 'printixGo'})
            }
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

        function deleteOnDeviceConfig () {
          var url = scope.onDeviceConfig.info._links.self.href;
          
          $http.delete(url).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
            if ($location.$$path.indexOf('goConfiguration') > 0) {
              $location.path('/settings').search({'settingsSection': 'printixGo'})
            }
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }


      }
    };
  }

  pxDeleteSignInProfile.$inject = ['$http', 'toastr', '$filter', '$rootScope', '$location'];

  angular
    .module('printix-admin')
    .directive('pxDeleteSignInProfile', pxDeleteSignInProfile);

})();
